import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_secured/campaign/$campaignId/settings/',
)({
  head: (ctx) => ({
    meta: [
      {
        title: `Settings – ${ctx.params.campaignId} | MINT`,
      },
    ],
  }),
});
